import { Login } from '../types/loginTypes';
import { BackendService } from './BackendService';

export default class CRMLoginsService {
  static createLogin(login: Omit<Login, 'id'>) {
    return BackendService.post<Login>('/logins', login);
  }

  static updateLogin(loginId: string, loginUpdate: Partial<Login>) {
    return BackendService.put(`/logins/${loginId}`, loginUpdate);
  }
}
